// ContextSection.js
import React from 'react';
import { FileText, Upload, Loader, Waves } from 'lucide-react';

export const ContextSection = ({ 
  contextFiles, 
  contextText, 
  fileInputRef, 
  isGenerating, 
  onGenerateContent, 
  onFileChange, 
  onTextChange 
}) => (
  <div className="bg-white rounded-lg shadow-lg p-6">
    <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
      <FileText className="w-5 h-5" />
      Context Information
    </h2>
    
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-2">Upload Reference Files</label>
        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          multiple
          className="hidden"
        />
        <button
          onClick={() => fileInputRef.current?.click()}
          className="flex items-center gap-2 px-4 py-2 border rounded hover:bg-gray-50"
        >
          <Upload className="w-4 h-4" />
          Choose Files
        </button>
        <div className="mt-2">
          {contextFiles.map((file, index) => (
            <div key={index} className="text-sm text-gray-600">{file.name}</div>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Additional Context</label>
        <textarea
          value={contextText}
          onChange={onTextChange}
          className="w-full p-2 border rounded"
          rows={4}
          placeholder="Add any additional context or special requirements..."
        />
      </div>

      <button
        onClick={onGenerateContent}
        disabled={isGenerating}
        className="w-full bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center gap-2 justify-center disabled:bg-gray-400"
      >
        {isGenerating ? (
          <>
            <Loader className="w-4 h-4 animate-spin" />
            Generating Content...
          </>
        ) : (
          <>
            <Waves className="w-4 h-4" />
            Generate AI Content
          </>
        )}
      </button>
    </div>
  </div>
);